var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"teacher-view-tab-class"}})}
var staticRenderFns = []

export { render, staticRenderFns }